import React, { useEffect } from 'react'
import { IoMdCloseCircle } from "react-icons/io";
import logo from "../../Asset/ordercard/logo.png";
import { useNavigate } from 'react-router-dom';
import AOS from "aos";
import "aos/dist/aos.css";

const OrderCard = ({setShowPopup}) => {
  const Navigate = useNavigate();
  useEffect(() => {
      AOS.init();
    }, []);
  return (
    <div className="w-full fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]">
           <div className="sm:w-[40%] w-full  rounded-3xl bg-Background1  p-5" data-aos="fade-down">
           <div className='w-full flex justify-end text-3xl text-textColor'>
            <span><IoMdCloseCircle className='cursor-pointer'  onClick={()=>{
              sessionStorage.removeItem("showOrderPopup");
              setShowPopup(false);
            }}/></span>
            </div>
            <div className='w-full flex justify-center items-center'>
              <div className='w-1/3' data-aos="flip-right">
                <img src={logo} className='w-full object-cover' alt="logo"/>
              </div>
              </div>
              <div className='flex justify-center my-2 text-2xl font-semibold text-textColor title1'>
                <span>Thank You</span>
              </div>
              <div className='flex justify-center text-textColor mb-8 title1'>
                <span className='text-[#A6A6A6] text-[14px]'>Your Order has been placed</span>
              </div>
              <div className='flex justify-center w-full'>
                <button className='bg-textColor text-white px-20 py-2.5 rounded-3xl title2 text-[14px]' onClick={()=>{Navigate(`/orderdetail/${sessionStorage.getItem("neworderid")}`)}}>Order Detail</button>
              </div>
              <div className='flex justify-center mt-4 text-textColor'>
                <span className='text-[#A6A6A6] text-[14px]'>Your order is on its way to fueling your best self!</span>
              </div>
          </div>
        </div>
  )
}

export default OrderCard
